import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
// import GD from "../RestAPI/getData";
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import AlertMessage from '../../../config/alertMessage';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { getIpAddress } from '../../../../common/getIpAddress';
import userStore from "../../../../store/userStore";
/* eslint-disable*/
class Frmnotesreadings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      PDF_Alert_status: false,
      PDFDownloadAlertStatus: false,
      MessageTitle: `${language.LC().MESSAGE}`,
      MessageContent: `${language.LC().NOTE_NOT_FOUND}`,
      PDFMessageTitle: App_data.messageTitle_frm,
      PDFMessageContent: AlertMessage.messageContent_frm,
      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params ? this.props.params.chapter : '',
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      chapterName: '',
      pdfLoading: true,
      chapterLevel: '',
      showFreePremium: true,
      type: 'notes',
      PDFContentMessage: language.LC().PDFContentMessage,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.PDFToggleAlert = this.PDFToggleAlert.bind(this);
    this.PDFDownloadAlertModel = this.PDFDownloadAlertModel.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }
  PDFToggleAlert() {
    this.setState({
      PDF_Alert_status: !this.state.PDF_Alert_status,
    });
  }

  PDFDownloadAlertModel() {
    this.setState({
      PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus,
    });
  }
  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  /*
  -------------------------------------------------------
    Function to redirect page to cfanotes page
  ------------------------------------------------------
  */
  _getChapters = e => {
    this.context.router.push({
      pathname: '/frm/notes/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  /*
  -------------------------------------------------------
    Function to redirect page to notes viewquestion  page
  ------------------------------------------------------
  */
  _getQuestions = (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: reading.chapter_no,
      offset: 0,
      limit: 1,
    };
    //console.log(data);
    FD.callAPI(App_data.backend_api + '/frm_notes/getNotes', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname:
              '/frm/notesview/' +
              reading.id +
              '/' +
              reading.chapter_no +
              '/' +
              reading.reading +
              '/' +
              this.state.chapterid,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: reading,
              chapter: this.state.chapterid,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };

  /*
  -------------------------------------------------------
    Function to redirect page on specifc questions
  ------------------------------------------------------
  */
  _beginChapter = (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: reading.chapter_no,
      offset: 0,
      limit: 1,
    };
    FD.callAPI(App_data.backend_api + '/frm_notes/getNotes', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname:
              '/frm/beginnotes/' +
              reading.chapter_no +
              '/' +
              reading.id +
              '/' +
              resp.questions[0].id +
              '/' +
              0 +
              '/' +
              reading.level,
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };

  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter: this.state.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/frm_notes/getReadings', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          readings: resp.readings,
          chapterName: resp.chaptername.chapter_name,
          chapterLevel: resp.chaptername.level,
        });
        if (!resp.readings.length) {
          this.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
    userStore.getUserProfile(true).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrmPDFSubscription(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrmPDFSubscription(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  }

  /*
----------------------------------
  Notes PDF DOWNLOAD Via Email
---------------------------------
*/
  getpdf = async e => {
    if (this.state.pdfLoading === false) {
      alert('Download is in process....');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
      chapterLevel: this.state.chapterLevel,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrmPDFSubscription(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,

                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_notes/PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = await FrmSubscriptionCheck.checkFrmPDFSubscription(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,

                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_notes/PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  };

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  render() {
    let readings = this.state.readings;
    let data = '';

    if (this.state.readings.length) {
      data = readings.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}.</td>
          <td>{item.reading}</td>
          <td>
            <span className='tooltip_wrap'>
              <img
                src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                className='pointer_class'
                style={{ textAlign: 'center' }}
                alt=''
                width='21'
                id={item.id}
                onClick={this._beginChapter.bind(this, item)}
                title=''
              />
              <div className='tootip_box'>{language.LC().READ_CHAPTER}</div>
            </span>
          </td>
        </tr>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.state.chapterName}</h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20 notes-download-reading-page'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}

                {this.state.showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoading ? language.LC().Download_Notes : '  please wait...'}
              </a>
            </div>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getChapters}
            >
              {' '}
              {language.LC().CHANGE_TOPIC}
            </button>
          </div>
          {/* </div> */}
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card height_70vh'>
              <div className='card-header'>
                {/* ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
                {language.LC().CHAPTER} {language.LC().READINGS}
              </div>
              <div className='table_responsive_wrapper'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <thead>
                      <tr className='border_top_0'>
                        <th width='90'>#</th>
                        <th>{language.LC().READING}</th>
                        <th>{language.LC().ACTION}</th>
                      </tr>
                    </thead>
                    <tbody>{data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader toggle={this.toggleAlert}>{this.state.MessageTitle}</ModalHeader>
          <ModalBody>{this.state.MessageContent}</ModalBody>
        </Modal>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.PDFToggleAlert.bind(this)}
          alert_status={this.state.PDF_Alert_status}
          MessageContent={this.state.PDFMessageContent}
        />
        <PDFModelComponent
          type={'Study Notes'}
          pdfAlertModel={this.PDFDownloadAlertModel.bind(this)}
          pdfAlert={this.state.PDFDownloadAlertStatus}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default Frmnotesreadings;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmNotes/Frmnotesreadings/Frmnotesreadings.js